"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Account/Audit/FilterBar.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);




var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _Popover = require('web/components/Popover'); var _Popover2 = _interopRequireDefault(_Popover);
var _Checkbox = require('web/screens/Broadcast/CampaignPage/Body/MessagesTable/components/Checkbox'); var _Checkbox2 = _interopRequireDefault(_Checkbox);
var _format = require('web/screens/Directory/PatientTable/format');


var _filters = require('./filters');














const SEARCH_DELAY_MS = 300
const PATIENT_RESULTS = 8

/* One filter: a pill that opens its popover, with × to clear it once set. */
const Pill











 = ({ name, label, showName = false, icon, isSet, isOpen, onToggle, onClose, onClear, children }) => {
  const ref = _react.useRef(null)
  return (
    _react2.default.createElement('div', { ref: ref, className: _classBuilder2.default.call(void 0, 'audit-pill', isSet && 'audit-pill--set'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}
      , _react2.default.createElement('button', { type: "button", className: "audit-pill--btn", 'aria-expanded': isOpen, 'aria-label': `${name}: ${label}`, onClick: onToggle, __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}
        , _react2.default.createElement('img', { alt: "", src: icon, __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}} )
        , _react2.default.createElement('span', { className: "audit-pill--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}},  showName && `${name}: ` ,  label )
        ,  !(isSet && onClear) && _react2.default.createElement('span', { className: "dir-toolbar--caret", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}, "▾") 
      )
      ,  isSet && onClear && (
        _react2.default.createElement('button', { type: "button", className: "audit-pill--clear", 'aria-label': `Clear ${name} filter`, onClick: onClear, __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}, "×")
      )
      ,  isOpen && (
        _react2.default.createElement(_Popover2.default, { anchorRef: ref, onClose: onClose, className: "dir-popover", __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
          , _react2.default.createElement('div', { className: "dir-filters audit-filters" , role: "group", 'aria-label': name, __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}},  children )
        )
      )
    )
  )
}

const Choice = ({ label, sub, isChosen, onChoose }) => (
  _react2.default.createElement('button', { type: "button", role: "menuitemradio", 'aria-checked': isChosen, className: _classBuilder2.default.call(void 0, 'audit-choice', isChosen && 'audit-choice--on'), onClick: onChoose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}
    , _react2.default.createElement('span', { className: "audit-choice--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}},  label )
    ,  sub && _react2.default.createElement('span', { className: "audit-choice--sub", __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}},  sub ) 
  )
)

const DatePanel = ({ range, onRange }) => {
  const today = _moment2.default.call(void 0, ).format('YYYY-MM-DD')
  const [isCustom, setIsCustom] = _react.useState.call(void 0, range.preset === 'custom')
  const [from, setFrom] = _react.useState.call(void 0, range.preset === 'custom' ? range.from : '')
  const [to, setTo] = _react.useState.call(void 0, range.preset === 'custom' ? range.to : today)
  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('div', { role: "menu", className: "audit-choices", __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}}
        ,  _filters.DATE_PRESETS.map(p => (
          _react2.default.createElement(Choice, { key: p.value, label: p.label, isChosen: range.preset === p.value, onChoose: () => onRange({ preset: p.value }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 83}} )
        ))
        , _react2.default.createElement(Choice, { label: "Custom range…" , isChosen: isCustom, onChoose: () => setIsCustom(true), __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}} )
      )
      ,  isCustom && (
        _react2.default.createElement('form', {
          className: "audit-custom",
          onSubmit: e => {
            e.preventDefault()
            if (from && to) onRange(from <= to ? { preset: 'custom', from, to } : { preset: 'custom', from: to, to: from })
          }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}

          , _react2.default.createElement('div', { className: "dir-filters--dates", __self: this, __source: {fileName: _jsxFileName, lineNumber: 95}}
            , _react2.default.createElement('input', { type: "date", className: "blm-text-input", 'aria-label': "From", value: from, onChange: e => setFrom(e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}} )
            , _react2.default.createElement('span', { className: "dir-filters--to", __self: this, __source: {fileName: _jsxFileName, lineNumber: 97}}, "to")
            , _react2.default.createElement('input', { type: "date", className: "blm-text-input", 'aria-label': "To", value: to, onChange: e => setTo(e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 98}} )
          )
          , _react2.default.createElement('button', { type: "submit", className: "blm-btn blm-btn--secondary audit-custom--apply"  , disabled: !from || !to, __self: this, __source: {fileName: _jsxFileName, lineNumber: 100}}, "Apply")
        )
      )
    )
  )
}

const PersonPanel



 = ({ people, person, onPerson }) => {
  const [query, setQuery] = _react.useState.call(void 0, '')
  const q = query.trim().toLowerCase()
  const matches = people.filter(p => !q || p.Name.toLowerCase().includes(q) || p.Email.toLowerCase().includes(q))
  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('input', {
        type: "search",
        className: "blm-text-input audit-search" ,
        placeholder: "Search people" ,
        'aria-label': "Search people" ,
        value: query,
        onChange: e => setQuery(e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 117}}
      )
      , _react2.default.createElement('div', { role: "menu", className: "audit-choices audit-choices--scroll" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 125}}
        ,  (!q || _filters.SUPPORT_NAME.toLowerCase().includes(q)) && (
          _react2.default.createElement(Choice, { label: _filters.SUPPORT_NAME, isChosen: _optionalChain([person, 'optionalAccess', _ => _.kind]) === 'support', onChoose: () => onPerson({ kind: 'support' }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 127}} )
        )
        ,  (!q || _filters.SYSTEM_NAME.toLowerCase().includes(q)) && (
          _react2.default.createElement(Choice, { label: _filters.SYSTEM_NAME, isChosen: _optionalChain([person, 'optionalAccess', _2 => _2.kind]) === 'system', onChoose: () => onPerson({ kind: 'system' }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 130}} )
        )
        ,  matches.map(p => (
          _react2.default.createElement(Choice, {
            key: p.UserKey,
            label: p.Name || p.Email,
            sub: p.Name ? p.Email : undefined,
            isChosen: _optionalChain([person, 'optionalAccess', _3 => _3.kind]) === 'user' && person.userKey === p.UserKey,
            onChoose: () => onPerson({ kind: 'user', userKey: p.UserKey, name: p.Name || p.Email }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 133}}
          )
        ))
        ,  matches.length === 0 && q && _react2.default.createElement('span', { className: "dir-cell--quiet", __self: this, __source: {fileName: _jsxFileName, lineNumber: 141}}, "No one matches."  ) 
      )
    )
  )
}

// Grouped checkboxes: a group's box ticks or clears all of its actions.
const ActionPanel



 = ({ options, chosen, onChosen }) => {
  const groups = _react.useMemo.call(void 0, () => {
    const byGroup = new Map()
    options.forEach(o => byGroup.set(o.Group, [..._nullishCoalesce(byGroup.get(o.Group), () => ( [])), o]))
    return [...byGroup.entries()]
  }, [options])
  const isOn = (a) => chosen.includes(a)
  const toggle = (a) => onChosen(isOn(a) ? chosen.filter(c => c !== a) : [...chosen, a])
  return (
    _react2.default.createElement('div', { className: "audit-actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 161}}
      ,  groups.map(([group, list]) => {
        const on = list.filter(o => isOn(o.Action)).length
        const all = on === list.length
        const toggleGroup = () => {
          const rest = chosen.filter(c => !list.some(o => o.Action === c))
          onChosen(all ? rest : [...rest, ...list.map(o => o.Action)])
        }
        return (
          _react2.default.createElement('fieldset', { key: group, className: "dir-filters--group", __self: this, __source: {fileName: _jsxFileName, lineNumber: 170}}
            , _react2.default.createElement('div', { className: "dir-filters--option audit-actions--group" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 171}}
              , _react2.default.createElement(_Checkbox2.default, { isChecked: all, isMixed: on > 0 && !all, label: group, onChange: toggleGroup, __self: this, __source: {fileName: _jsxFileName, lineNumber: 172}} )
              , _react2.default.createElement('button', { type: "button", className: "dir-filters--name", onClick: toggleGroup, __self: this, __source: {fileName: _jsxFileName, lineNumber: 173}},  group )
            )
            , _react2.default.createElement('div', { className: "audit-actions--list", __self: this, __source: {fileName: _jsxFileName, lineNumber: 175}}
              ,  list.map(o => (
                _react2.default.createElement('div', { key: o.Action, className: "dir-filters--option", __self: this, __source: {fileName: _jsxFileName, lineNumber: 177}}
                  , _react2.default.createElement(_Checkbox2.default, { isChecked: isOn(o.Action), label: o.Label, onChange: () => toggle(o.Action), __self: this, __source: {fileName: _jsxFileName, lineNumber: 178}} )
                  , _react2.default.createElement('button', { type: "button", className: "dir-filters--name", onClick: () => toggle(o.Action), __self: this, __source: {fileName: _jsxFileName, lineNumber: 179}},  o.Label )
                )
              ))
            )
          )
        )
      })
    )
  )
}

const patientSub = (p) => [
  _format.formatDOB.call(void 0, p.DateOfBirth) && `DOB ${_format.formatDOB.call(void 0, p.DateOfBirth)}`,
  p.ForeignID && `MRN ${p.ForeignID}`,
].filter(Boolean).join(' · ')

/* The Directory's patient search (ListOrgPatients), in each org searched. */
const PatientPanel = ({ orgKeys, onPatient }) => {
  const [query, setQuery] = _react.useState.call(void 0, '')
  const [results, setResults] = _react.useState(null)
  const q = query.trim()
  const keysId = orgKeys.join(',')
  _react.useEffect.call(void 0, () => {
    if (!q) return undefined
    let isCurrent = true
    const timer = setTimeout(() => {
      // SAFETY: keysId is orgKeys joined, so each part is an OrgKey.
      Promise.all(keysId.split(',').filter(Boolean).map(k => _actions2.default.listOrgPatients({
        OrgKey: k , Archived: false, Query: q, Sort: 'name', Desc: false, Offset: 0, Limit: PATIENT_RESULTS,
      })))
        .then(pages => { if (isCurrent) setResults({ query: q, rows: pages.flatMap(p => p.Patients), hasFailed: false }) })
        .catch(() => { if (isCurrent) setResults({ query: q, rows: [], hasFailed: true }) })
    }, SEARCH_DELAY_MS)
    return () => {
      isCurrent = false
      clearTimeout(timer)
    }
  }, [q, keysId])
  const shown = q && _optionalChain([results, 'optionalAccess', _4 => _4.query]) === q ? results : null
  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('input', {
        type: "search",
        className: "blm-text-input audit-search" ,
        placeholder: "Search by name or MRN"    ,
        'aria-label': "Search patients" ,
        value: query,
        onChange: e => setQuery(e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 220}}
      )
      ,  shown && (
        _react2.default.createElement('div', { role: "menu", className: "audit-choices audit-choices--scroll" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 229}}
          ,  shown.rows.map(p => (
            _react2.default.createElement(Choice, { key: p.PatientKey, label: p.Name, sub: patientSub(p), isChosen: false, onChoose: () => onPatient(p), __self: this, __source: {fileName: _jsxFileName, lineNumber: 231}} )
          ))
          ,  shown.rows.length === 0 && (
            _react2.default.createElement('span', { className: "dir-cell--quiet", __self: this, __source: {fileName: _jsxFileName, lineNumber: 234}},  shown.hasFailed ? 'Couldn\'t search patients.' : 'No patients match.' )
          )
        )
      )
    )
  )
}

const actionsLabel = (chosen, options) => {
  if (chosen.length === 0) return 'All actions'
  if (chosen.length === 1) return _nullishCoalesce(_optionalChain([options, 'access', _5 => _5.find, 'call', _6 => _6(o => o.Action === chosen[0]), 'optionalAccess', _7 => _7.Label]), () => ( '1 action'))
  const groups = new Set(options.filter(o => chosen.includes(o.Action)).map(o => o.Group))
  const [group] = groups
  if (group && groups.size === 1 && options.filter(o => o.Group === group).length === chosen.length) return group
  return `${chosen.length} actions`
}

/* Date, Organization (when the account has several), Person, Action and
 * Patient, then the toolbar's extra (Download CSV). */
const FilterBar = ({ filters, onFilters, options, orgKeys, extra }) => {
  const [open, setOpen] = _react.useState(null)
  const toggle = (p) => () => setOpen(o => o === p ? null : p)
  const close = () => setOpen(null)
  const set = (f) => {
    onFilters({ ...filters, ...f })
    close()
  }
  const orgs = _nullishCoalesce(_optionalChain([options, 'optionalAccess', _8 => _8.Orgs]), () => ( []))
  const orgName = _optionalChain([orgs, 'access', _9 => _9.find, 'call', _10 => _10(o => o.OrgKey === filters.orgKey), 'optionalAccess', _11 => _11.Name])
  const personLabel = _optionalChain([filters, 'access', _12 => _12.person, 'optionalAccess', _13 => _13.kind]) === 'support'
    ? _filters.SUPPORT_NAME
    : _optionalChain([filters, 'access', _14 => _14.person, 'optionalAccess', _15 => _15.kind]) === 'system' ? _filters.SYSTEM_NAME : _optionalChain([filters, 'access', _16 => _16.person, 'optionalAccess', _17 => _17.name])

  return (
    _react2.default.createElement('div', { className: "audit-toolbar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 268}}
      , _react2.default.createElement(Pill, {
        name: "Date",
        label: _filters.rangeLabel.call(void 0, filters.range),
        icon: "/assets/icons/icon-calendar-purple.svg",
        isSet: filters.range.preset !== '30d',
        isOpen: open === 'date',
        onToggle: toggle('date'),
        onClose: close, __self: this, __source: {fileName: _jsxFileName, lineNumber: 269}}

        , _react2.default.createElement(DatePanel, { range: filters.range, onRange: range => set({ range }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 278}} )
      )
      ,  orgs.length > 1 && (
        _react2.default.createElement(Pill, {
          name: "Organization",
          label: _nullishCoalesce(orgName, () => ( 'All organizations')),
          icon: "/assets/icons/team-grey.svg",
          isSet: !!filters.orgKey,
          isOpen: open === 'org',
          onToggle: toggle('org'),
          onClose: close,
          onClear: () => set({ orgKey: undefined }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 281}}

          , _react2.default.createElement('div', { role: "menu", className: "audit-choices", __self: this, __source: {fileName: _jsxFileName, lineNumber: 291}}
            ,  orgs.map(o => (
              _react2.default.createElement(Choice, { key: o.OrgKey, label: o.Name, isChosen: filters.orgKey === o.OrgKey, onChoose: () => set({ orgKey: o.OrgKey }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 293}} )
            ))
          )
        )
      )
      , _react2.default.createElement(Pill, {
        name: "Person",
        label: _nullishCoalesce(personLabel, () => ( 'Anyone')),
        icon: "/assets/icons/user-purple.svg",
        isSet: !!filters.person,
        isOpen: open === 'person',
        onToggle: toggle('person'),
        onClose: close,
        onClear: () => set({ person: undefined }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 298}}

        , _react2.default.createElement(PersonPanel, { people: _nullishCoalesce(_optionalChain([options, 'optionalAccess', _18 => _18.People]), () => ( [])), person: filters.person, onPerson: person => set({ person }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 308}} )
      )
      , _react2.default.createElement(Pill, {
        name: "Action",
        label: actionsLabel(filters.actions, _nullishCoalesce(_optionalChain([options, 'optionalAccess', _19 => _19.Actions]), () => ( []))),
        icon: "/assets/icons/filter-grey.svg",
        isSet: filters.actions.length > 0,
        isOpen: open === 'action',
        onToggle: toggle('action'),
        onClose: close,
        onClear: () => set({ actions: [] }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 310}}

        , _react2.default.createElement(ActionPanel, {
          options: _nullishCoalesce(_optionalChain([options, 'optionalAccess', _20 => _20.Actions]), () => ( [])),
          chosen: filters.actions,
          onChosen: a => onFilters({ ...filters, actions: a }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 320}}
        )
      )
      , _react2.default.createElement(Pill, {
        name: "Patient",
        label: filters.patient ? filters.patient.name : 'Any patient',
        showName: !!filters.patient,
        icon: "/assets/icons/search-grey.svg",
        isSet: !!filters.patient,
        isOpen: open === 'patient',
        onToggle: toggle('patient'),
        onClose: close,
        onClear: () => set({ patient: undefined }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 326}}

        , _react2.default.createElement(PatientPanel, {
          orgKeys: filters.orgKey ? [filters.orgKey] : orgKeys,
          onPatient: p => set({ patient: { patientKey: p.PatientKey, name: p.Name } }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 337}}
        )
      )
      , _react2.default.createElement('span', { className: "audit-toolbar--spacer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 342}} )
      ,  extra 
    )
  )
}

exports. default = FilterBar
